import Vue from 'vue';
import VueRouter from 'vue-router';
import jwtService from '@/services/common/jwt.service';
import messageModule from '@/store/modules/common/message.module';
import menuModule from '@/store/modules/common/menu.module';

export const LOGIN = 'login';
export const HOME = 'home';
export const REGISTER = 'register';
export const PASSWORD_FORGOT = 'password.forgot';
export const PASSWORD_CHANGE = 'password.change';
export const PASSWORD_RESET = 'password.reset';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: '',
    component: () => import('@/containers/layout/MainLayout.vue'),
    redirect: '/home',
    children: [
      {
        path: '/home',
        name: HOME,
        component: () => import('@/views/mastercoach/Home.vue')
      },
      {
        path: '/reports',
        name: 'reports',
        component: () => import('@/views/mastercoach/Report.vue')
      },
      {
        path: '/report-form',
        name: 'report.form',
        component: () => import('@/views/mastercoach/ReportForm.vue')
      },
      {
        path: '/report-detail',
        name: 'report.detail',
        component: () => import('@/views/mastercoach/ReportDetail.vue'),
        redirect: '/report-detail/chart',
        children: [
          {
            path: 'chart',
            name: 'report.detail.chart',
            component: () => import('@/components/report/ReportChart.vue')
          },
          {
            path: 'table',
            name: 'report.detail.table',
            component: () => import('@/components/report/ReportTable.vue')
          }
        ]
      },
      {
        path: '/report-detail-individual',
        name: 'report-individual.detail',
        component: () =>
          import('@/views/mastercoach/ReportIndividualDetail.vue'),
        redirect: '/report-detail-individual/chart',
        children: [
          {
            path: 'chart',
            name: 'report-individual.detail.chart',
            component: () =>
              import('@/components/report/ReportIndividualChart.vue')
          },
          {
            path: 'table',
            name: 'report-individual.detail.table',
            component: () =>
              import('@/components/report/ReportIndividualTable.vue')
          }
        ]
      },

      {
        path: '/manager',
        name: 'manager',
        component: () => import('@/views/mastercoach/Manager.vue')
      },
      {
        path: '/coaches',
        name: 'coaches',
        component: () => import('@/views/mastercoach/Coaches.vue')
      },
      {
        path: '/coach-clients',
        name: 'coach-clients',
        component: () => import('@/views/mastercoach/CoachClients.vue')
      },
      {
        path: '/change-password',
        name: PASSWORD_CHANGE,
        component: () => import('@/views/common/ChangePassword.vue')
      },
      {
        path: '/admin-info',
        name: 'admin-info',
        component: () => import('@/views/mastercoach/AdminInfo.vue')
      },
      {
        path: '/goal-list',
        name: 'client',
        component: () => import('@/views/mastercoach/Goals.vue')
      }
    ]
  },
  {
    path: '/auth',
    name: 'auth',
    component: () => import('@/containers/layout/BeforeLoginLayout.vue'),
    redirect: '/auth/login',
    children: [
      {
        path: 'login',
        name: LOGIN,
        component: () => import('@/views/common/Login.vue')
      },
      {
        path: 'register',
        name: REGISTER,
        component: () => import('@/views/common/Register.vue')
      },
      {
        path: 'forgot-password',
        name: PASSWORD_FORGOT,
        component: () => import('@/views/common/ForgotPassword.vue')
      },
      {
        path: 'reset-password/:key',
        name: PASSWORD_RESET,
        component: () => import('@/views/common/ResetPassword.vue')
      }
    ]
  }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

router.beforeEach(async (to, from, next) => {
  await menuModule.updatePreviousPath(from);
  await messageModule.setMessage(null);
  if (
    ![
      LOGIN,
      REGISTER,
      PASSWORD_FORGOT,
      PASSWORD_RESET,
      PASSWORD_CHANGE
    ].includes((to && to.name) || '') &&
    !jwtService.getToken()
  ) {
    next({ name: LOGIN });
  } else {
    next();
  }
});

export default router;
